import type { HelpFile } from '../../types/help'
import { IdentityStepTestIds } from '../../../testids/IdentityStepTestIds'

export const identityStepHelp: HelpFile = {
  docPage: '/docs/onboarding/identity-step',
  texts: {
    [IdentityStepTestIds.btnAddIdentifier]: 'Einen weiteren Identifier (z. B. E-Mail, Personalnummer) zu der zu onboardenden Identität hinzufügen.',
    [IdentityStepTestIds.cardTitleExistingIdentifiers]: 'Bereits mit der Partei verknüpfte Identifikatoren — hilft, Duplikate zu erkennen.',
    [IdentityStepTestIds.cardTitleExistingIdentities]: 'Bestehende Identitäten dieser Partei — eine davon erweitern statt ein Duplikat anzulegen.',
    [IdentityStepTestIds.cardTitleIdentifiers]: 'Identifier, die diese Identität in den Quellsystemen eindeutig referenzieren.',
    [IdentityStepTestIds.cardTitleIdentityAttributes]: 'Identitätsspezifische Attribute wie Funktion, Abteilung oder Standort.',
    [IdentityStepTestIds.cardTitleIdentityDetails]: 'Kernangaben der Identität: Typ, Gültigkeitsdaten und primärer Identifier.',
    [IdentityStepTestIds.inputEntryDate]: 'Datum, ab dem diese Identität aktiv ist. Vor diesem Datum erfolgt keine Bereitstellung.',
    [IdentityStepTestIds.inputExitDate]: 'Datum, an dem diese Identität automatisch deaktiviert wird. Leer lassen für unbefristet.',
    [IdentityStepTestIds.selectIdentityType]: 'Art der zu onboardenden Identität wählen — etwa Mitarbeiter, Auftragnehmer oder Dienst.',
  },
}
